import {Selector} from '@ngxs/store';
import {AdvertiserDevicesState} from './advertiser-devices.state';
import {AdvertiserDevicesModel} from './advertiser-devices.model';
import {LatLngBounds} from 'leaflet';
import {IResponse} from '@interfaces/response';
import {IDeviceAdvertiser} from '@interfaces/advertiser/devices';

export class AdvertiserDevicesSelectors {
  @Selector([AdvertiserDevicesState])
  static getAdvertiserMapBounds(state: AdvertiserDevicesModel): LatLngBounds | null {
    return state.mapBounds;
  }

  @Selector([AdvertiserDevicesState])
  static getAdvertiserDevices(state: AdvertiserDevicesModel): IResponse<IDeviceAdvertiser> | null {
    return state.devices;
  }

  @Selector([AdvertiserDevicesState])
  static getAdvertiserDevicesSearch(state: AdvertiserDevicesModel): string {
    return state.searchParam;
  }

  @Selector([AdvertiserDevicesState])
  static getAdvertiserDevicesCurrentPage(state: AdvertiserDevicesModel): number {
    return state.devicesConfig.currentPage;
  }

  @Selector([AdvertiserDevicesState])
  static getAdvertiserDevicesPerPage(state: AdvertiserDevicesModel): number {
    return state.devicesConfig.itemsPerPage;
  }

  @Selector([AdvertiserDevicesState])
  static getAdvertiserDevicesLoader(state: AdvertiserDevicesModel): boolean {
    return state.devicesConfig.isLoading;
  }
}
